import type { TalentCategory, TalentConfigBoss } from "../talent-config-api"

const CATEGORY_TIER_BASE: Record<TalentCategory, number> = {
  offensive: 1,
  defensive: 4,
  strategic: 7,
}

const CATEGORY_TIER_LIMIT: Record<TalentCategory, number> = {
  offensive: 3,
  defensive: 3,
  strategic: 3,
}

export function getNextTalentSlot(
  boss: TalentConfigBoss,
  category: TalentCategory,
): { tier: number } | null {
  const start = CATEGORY_TIER_BASE[category]
  const end = start + CATEGORY_TIER_LIMIT[category] - 1
  const used = new Set(
    boss.talentsByCategory[category].map((talent) => talent.tier),
  )

  for (let tier = start; tier <= end; tier += 1) {
    if (!used.has(tier)) {
      return { tier }
    }
  }

  return null
}
